import { render, staticRenderFns } from "./BlogInfoHeader.vue?vue&type=template&id=3bec172c&scoped=true&"
import script from "./BlogInfoHeader.vue?vue&type=script&lang=js&"
export * from "./BlogInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlogInfoHeader.vue?vue&type=style&index=0&id=3bec172c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec172c",
  null
  
)

export default component.exports